export interface NavItem {
  label: string;
  href: string;
  children?: NavItem[];
}

export const mainNavigation: NavItem[] = [
  {
    label: 'About Us', href: '/about-us'
  },
  {
    label: 'Our Expertise', href: '/services',
    children: [
      { label: 'All Services', href: '/services' },
      { label: 'Strategic Diagnosis', href: '/services/strategic-diagnosis' },
      { label: 'Strategic Alignment', href: '/services/strategic-alignment' },
      { label: 'Learning & Development', href: '/services/learning-development' },
      { label: 'Human Capital Advisory', href: '/services/human-capital-advisory' },
    ]
  },
  {
    label: 'Insights',
    href: '/insights',
    // Children built dynamically in Header from ServiceCategory + Footprints
  },
  {
    label: 'Life at Simisi', href: '/life-at-simisi'
  },
  // { label: 'Our People', href: '/our-people' },

];
